import { ACTIONS, ActionType } from "actions/annualClock/types";
import produce, { Draft } from "immer";
import { LoadingState } from "types/api";
import { AnnualClockState } from "./types";

export const initialState = {
    data: null,
    status: LoadingState.idle,
};

const annualClock = produce((state: Draft<AnnualClockState>, action: ActionType) => {
    switch (action.type) {
        case ACTIONS.GET_ANNUAL_CLOCK_REQUEST:
            state.status = LoadingState.loading;
            break;
        case ACTIONS.GET_ANNUAL_CLOCK_SUCCESS: {
            state.status = LoadingState.success;
            state.data = action.payload;
            break;
        }
        case ACTIONS.GET_ANNUAL_CLOCK_FAILURE:
            state.status = LoadingState.failure;
            break;
    }
}, initialState);

export default annualClock;
